var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.196 7.02323C14.196 10.3532 11.3048 13.0465 7.74252 13.0465L6.9423 14.0102L6.46904 14.5781C6.06462 15.06 5.2902 14.9567 5.02346 14.3802L3.87045 11.8418C2.30441 10.7404 1.28906 8.99368 1.28906 7.02323C1.28906 3.69324 4.18021 1 7.74252 1C10.3411 1 12.5869 2.43698 13.5937 4.50208C13.9809 5.26789 14.196 6.11974 14.196 7.02323Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4974 10.345C18.4974 12.3154 17.482 14.0622 15.916 15.1636L14.763 17.7019C14.4962 18.2784 13.7218 18.3903 13.3174 17.8998L12.0439 16.3682C9.96162 16.3682 8.10303 15.4475 6.94141 14.0105L7.74163 13.0468C11.3039 13.0468 14.1951 10.3536 14.1951 7.02359C14.1951 6.1201 13.98 5.26825 13.5928 4.50244C16.4065 5.14779 18.4974 7.52264 18.4974 10.345Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58594 7.02344H9.88824",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportLogo);
export default __webpack_public_path__ + "static/media/supportLogo.1fce679ace27bea6d1d8a2387f7486fb.svg";
export { ForwardRef as ReactComponent };